import React, { Component } from 'react';
import { Row, Label, Col, Modal, ModalBody, Button, Input, Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import axios from '../../../../axios';
import * as url from '../../../../utils/url';
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
  } from 'react-places-autocomplete';
import { classnames } from '../../../../utils/place-autocomplete-helpers';
import Select from 'react-select';
import './EditOfficeModal.css';

export default class EditOfficeModal extends Component {
  constructor(props) {
      super(props);
      this.state = {
        showEditOfficeInfoModal: this.props.showEditOfficeInfoModal,
        name: this.props.name,
        industry: (this.props.officeDetails.organizationId && this.props.officeDetails.organizationId.industry) ? this.props.officeDetails.organizationId.industry.name : '',
        displayName: this.props.officeDetails.displayName || '',
        officeFunction: {value: this.props.officeDetails.occupation, error: false},
        productType: this.props.officeDetails.productType,
        customerType: this.props.officeDetails.customerType,
        officeFunctions: this.props.officeFunctions,
        productTypes: this.props.productTypes,
        customerTypes: this.props.customerTypes,
        address: {value : (this.props.officeDetails.address && this.props.officeDetails.address.fullAddress) ? this.props.officeDetails.address.fullAddress : ''},
        state: (this.props.officeDetails.address && this.props.officeDetails.address.state) ? this.props.officeDetails.address.state : '',
        latitude: this.props.officeDetails.latitude,
        longitude: this.props.officeDetails.longitude,
        officeNamePopoverOpen: false,
        industryPopoverOpen: false,
      }
  }

    toggleOfficeNamePopover = () => {
        this.setState({
            officeNamePopoverOpen: !this.state.officeNamePopoverOpen,
            industryPopoverOpen: false
        });
    }

    toggleIndustryPopover = () => {
        this.setState({
            industryPopoverOpen: !this.state.industryPopoverOpen,
            officeNamePopoverOpen: false
        });
    }

    handleChangeOfficeFunction = (value) => {
        this.setState({
            officeFunction: {value: value}
        })
    }

    handleChangeCustomerType = (value) => {
        this.setState({
            customerType: value
        })
    }

    handleChangeProductType = (value) => {
        this.setState({
            productType: value
        })
    }

    handleAddressChange = (address) => {
        this.setState({
            address: { value: address}, latitude: null, longitude: null
        })
    }

    handleSelect = address => {
        this.setState({ address: address });
        geocodeByAddress(address)
            .then(results => {
                const result = results[0];
                getLatLng(results[0]).then((latLng) => {
                    let state = '';
                    for (let i = 0; i < result.address_components.length; i++) {
                        const address = result.address_components[i];
                        // console.log(address);
                        if (address.types.indexOf("administrative_area_level_1") > -1) {
                            state = address.long_name;
                        }
                    }
                    this.setState({
                        address: {value: address},
                        latitude: latLng.lat,
                        longitude: latLng.lng,
                        state: state
                    });
                })
            })
            .catch(error => console.error('Error', error));
    };

    handleEditOfficeInfo = () => {
        let { officeFunction, productType, customerType, displayName, address, latitude, longitude, state} = { ...this.state };
        if(!officeFunction || !officeFunction.value || !officeFunction.value._id) {
            this.setState({officeFunction: {value: {}, error: true, errorMessage: 'Please enter the main function of your office.'}});
            return;
        }
        if(!address || address.value.trim() === '') {
            this.setState({address: {value: '', error: true, errorMessage: 'Please enter the main location of your office.'}});
            return;
        }

        const formData = new FormData();
        if (displayName) {
            formData.append("displayName", displayName);
        }
        if (officeFunction && officeFunction.value._id) {
            formData.append("occupation", officeFunction.value._id);
        }
        if (productType && productType._id) {
            formData.append("productType", productType._id);
        }
        if (customerType && customerType._id) {
            formData.append("customerType", customerType._id);
        }
        if (address) {
            formData.append("fullAddress", address.value);
        }
        if (latitude && latitude !== null) {
            formData.append("latitude", latitude);
        }
        if (longitude && longitude !== null) {
            formData.append("longitude", longitude);
        }
        if(state && state !== null) {
            formData.append("state",state);
        }

        const { officeDetails } = this.props;
        axios.put(url.updateOffice(officeDetails._id), formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((response) => {
            // console.log(response.data.data);
            this.props.editSuccess();
        }).catch((error) => {
            //todo show error
        });
    }

    render() {
        let { showEditOfficeInfoModal, officeNamePopoverOpen, industryPopoverOpen, officeFunctions, productTypes, customerTypes,
            officeFunction, productType, customerType, displayName, address, industry } = { ...this.state };
        return (<Modal isOpen={showEditOfficeInfoModal} className="office-info-modal">
            <ModalBody className="profile-modal-body">
                <Row className="mlmr0">
                    <span className="col-sm-6 col-md-6 office-modal-heading-txt">Edit Office Information</span>
                </Row>
                <Row className="mlmr0 mt30">
                    <Col sm={5} className="d-flex justify-content-end align-items-center">
                        <span id="office-name-popover" className="d-flex mr10" onClick={this.toggleOfficeNamePopover}><Tooltip /></span>
                        <Popover placement="left" isOpen={officeNamePopoverOpen} target="office-name-popover" toggle={this.toggleOfficeNamePopover}>
                            <PopoverHeader className="popover-header-tooltip">Office Name</PopoverHeader>
                            <PopoverBody className="popover-body-tooltip">Your Office Name can only be changed by your enterprise admin by uploading a new enterprise org chart. To see it differently, you can edit the optional "Office Display Name" field below.</PopoverBody>
                        </Popover>
                        <span className="office-modal-label">Office Name</span>
                    </Col>
                    <Col sm={7}>
                        <Input type="text" value={this.props.officeDetails.name} disabled />
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5} className="d-flex justify-content-end align-items-center">
                        <span id="industry-popover" className="d-flex mr10" onClick={this.toggleIndustryPopover}><Tooltip /></span>
                        <Popover placement="left" isOpen={industryPopoverOpen} target="industry-popover" toggle={this.toggleIndustryPopover}>
                            <PopoverHeader className="popover-header-tooltip">Industry</PopoverHeader>
                            <PopoverBody className="popover-body-tooltip">Your Industry is set as part of the enterprise on-boarding process. Contact your enterprise admin if a change is needed.</PopoverBody>
                        </Popover>
                        <span className="office-modal-label">Industry</span>
                    </Col>
                    <Col sm={7}>
                        <Input type="text" value={industry} disabled />
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5} className="office-modal-label text-right">
                        Office Display Name
                      <div className="modal-optional-txt">(optional)</div>
                    </Col>
                    <Col sm={7}>
                        <Input type="text" 
                        value={displayName}
                        onChange = {({target}) => this.setState({
                            displayName: target.value
                        })}
                        />
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5}>
                        <div className="text-right office-modal-label">Function</div>
                    </Col>
                    <Col sm={7}>
                        <Select
                            name="function-select"
                            placeholder={"Select"}
                            value={officeFunction.value}
                            options={officeFunctions}
                            onChange={this.handleChangeOfficeFunction}
                            valueKey='_id'
                            labelKey='name'
                            className={officeFunction.error ? 'select-error-field': ''}
                        />
                        {(officeFunction.error) ? <div className="input-error-msg-field">{officeFunction.errorMessage}</div> : null}
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5} className="text-right">
                        <span className="office-modal-label">Product Type</span>
                        <div className="modal-optional-txt">(optional)</div>
                    </Col>
                    <Col sm={7}>
                        <Select
                            name="product-type-select"
                            placeholder={"Select"}
                            value={productType}
                            options={productTypes}
                            onChange={this.handleChangeProductType}
                            valueKey='_id'
                            labelKey='name'
                        />
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5} className="text-right">
                        <span className="office-modal-label">Customer Type</span>
                        <div className="modal-optional-txt">(optional)</div>
                    </Col>
                    <Col sm={7}>
                        <Select
                            name="customer-type-select"
                            placeholder={"Select"}
                            value={customerType}
                            options={customerTypes}
                            onChange={this.handleChangeCustomerType}
                            valueKey='_id'
                            labelKey='name'
                        />
                    </Col>
                </Row>
                <Row className="mlmr0 mt20">
                    <Col sm={5} className="text-right">
                        <span className="office-modal-label">Location</span>
                    </Col>
                    <Col sm={7}>
                        <PlacesAutocomplete
                            onChange={this.handleAddressChange}
                            value={address.value}
                            onSelect={this.handleSelect}
                            onError={this.handleError}
                            shouldFetchSuggestions={address.value && address.value.length > 2}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps }) => {
                                return (
                                    <div>
                                        <div className={"search-input-container"}>
                                            <input
                                                {...getInputProps({
                                                    placeholder: 'Start typing address of your office',
                                                    className: address.error ? 'search-input-error' : 'search-input'
                                                })}
                                            />
                                        </div>
                                        {suggestions.length > 0 && (
                                            <div className="autocomplete-container">
                                                {suggestions.map(suggestion => {
                                                    const className = classnames('suggestion-item', {
                                                        'suggestion-item--active': suggestion.active,
                                                    });

                                                    return (
                                                        /* eslint-disable react/jsx-key */
                                                        <div
                                                            {...getSuggestionItemProps(suggestion, { className })}
                                                        >
                                                            <strong>
                                                                {suggestion.formattedSuggestion.mainText}
                                                            </strong>{' '}
                                                            <small>
                                                                {suggestion.formattedSuggestion.secondaryText}
                                                            </small>
                                                        </div>
                                                    );
                                                    /* eslint-enable react/jsx-key */
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            }}
                        </PlacesAutocomplete>
                        {(address.error) ? <div className="input-error-msg-field">{address.errorMessage}</div> : null}                          
                    </Col>
                </Row>
                <Row className="mlmr0 mt30">
                    <Col sm={{ size: 4, offset: 5 }} md={{ size: 4, offset: 5 }}>
                        <Button className="profile-modal-save-btn" onClick={this.handleEditOfficeInfo}>
                            <span className="profile-modal-save-btn-txt">Save
                            <span className="ml10 flaticon-tick"></span></span>
                        </Button>
                    </Col>
                    <Col sm={{ size: 3 }} md={{ size: 3 }}>
                        <Button className="profile-modal-cancel-btn"
                            onClick={this.props.closeModal}>
                            <span className="profile-modal-cancel-btn-txt">Cancel</span>
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>);
  }
}
